var _filter, _clipPath, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(51.372549%,58.431373%,21.568627%)",
      fillOpacity: 1
    },
    d: "M 59.824219 15.523438 L 23.726562 51.636719 C 22.726562 52.636719 21.476562 53.3125 20.113281 53.625 C 21.25 54.425781 22.613281 54.875 24.011719 54.875 C 25.800781 54.875 27.523438 54.164062 28.789062 52.898438 L 62.988281 18.699219 Z M 59.824219 15.523438 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.431373%,87.45098%,54.901961%)",
      fillOpacity: 1
    },
    d: "M 53.4375 9.136719 L 25.375 37.199219 C 24.613281 37.960938 23.386719 37.960938 22.636719 37.199219 L 10.5625 25.125 L 1.011719 34.664062 L 19.238281 52.886719 C 20.5 54.148438 22.226562 54.863281 24.011719 54.863281 C 25.800781 54.863281 27.523438 54.148438 28.789062 52.886719 L 62.988281 18.6875 Z M 53.4375 9.136719 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.011719 55.875 C 21.9375 55.875 19.988281 55.0625 18.523438 53.601562 L 0.300781 35.375 C -0.101562 34.976562 -0.101562 34.335938 0.300781 33.9375 L 9.851562 24.386719 C 10.25 23.988281 10.886719 23.988281 11.289062 24.386719 L 14.875 27.976562 C 15.273438 28.375 15.273438 29.011719 14.875 29.414062 C 14.476562 29.8125 13.835938 29.8125 13.4375 29.414062 L 10.574219 26.550781 L 2.460938 34.664062 L 19.976562 52.175781 C 21.0625 53.261719 22.5 53.851562 24.039062 53.851562 C 25.574219 53.851562 27.011719 53.25 28.101562 52.175781 L 51.476562 28.800781 C 51.875 28.398438 52.511719 28.398438 52.914062 28.800781 C 53.3125 29.199219 53.3125 29.835938 52.914062 30.238281 L 29.539062 53.613281 C 28.023438 55.074219 26.085938 55.875 24.011719 55.875 Z M 24.011719 55.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.011719 38.773438 C 23.226562 38.773438 22.488281 38.460938 21.925781 37.914062 L 16.289062 32.273438 C 15.886719 31.875 15.886719 31.238281 16.289062 30.835938 C 16.6875 30.4375 17.324219 30.4375 17.726562 30.835938 L 23.363281 36.476562 C 23.539062 36.648438 23.773438 36.75 24.011719 36.75 C 24.25 36.75 24.488281 36.648438 24.664062 36.476562 L 52.726562 8.425781 C 53.125 8.023438 53.761719 8.023438 54.164062 8.425781 L 63.710938 17.976562 C 63.898438 18.164062 64.011719 18.425781 64.011719 18.6875 C 64.011719 18.949219 63.898438 19.210938 63.710938 19.398438 L 55.726562 27.375 C 55.324219 27.773438 54.6875 27.773438 54.289062 27.375 C 53.886719 26.976562 53.886719 26.335938 54.289062 25.9375 L 61.550781 18.675781 L 53.4375 10.5625 L 26.101562 37.914062 C 25.539062 38.476562 24.800781 38.773438 24.011719 38.773438 Z M 24.011719 38.773438 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.92439a231c92178e54c4d6e3b9272fe6.svg";
export { ForwardRef as ReactComponent };